import UserAvatarPlaceholder from '../../../UserAvatarPlaceholder';

const ProjectMember = ({ data = {} }) => {
    const classes = ['briefAuthorWrapper'];

    return (
        <div className={classes.join(' ')}>
            <div className="briefAuthor">
                <div className="userAvatar">
                    {data.profile_picture_url
                        ? <img src={data.profile_picture_url} alt={data.name} />
                        : <UserAvatarPlaceholder className="userAvatar__placeholder" />}
                </div>
                <div className="userMeta">
                    <span className="userName">{data.name} {data.surname}{data.status === 'PENDING' ? <small>{data.status}</small> : null}</span>
                    <span className="userPosition">{data.role}</span>
                </div>
            </div>
        </div>
    );
};

export default ProjectMember;
